import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
import api from 'core/util/api';
import { action, observable, runInAction } from 'mobx';

/**
 * Map indicating the presence of device traps within the last two weeks, keyed by device ID which are ints but you know... javascript.
 */
let DeviceTrapsStatusStore = (_dec = observable.ref, _dec2 = observable.ref, _class = class DeviceTrapsStatusStore {
  constructor() {
    _initializerDefineProperty(this, "fetched", _descriptor, this);
    _initializerDefineProperty(this, "lastFetched", _descriptor2, this);
    _initializerDefineProperty(this, "fetchPromise", _descriptor3, this);
    _initializerDefineProperty(this, "getDeviceTrapsStatus", _descriptor4, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "fetched", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "lastFetched", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "fetchPromise", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "getDeviceTrapsStatus", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return () => {
      if (!this.fetchPromise) {
        this.fetchPromise = api.get('/api/ui/devices/traps/query').then(results => {
          runInAction(() => {
            this.fetched = true;
            this.lastFetched = results;
          });
          return results;
        }).catch(error => {
          runInAction(() => {
            this.fetchPromise = null;
          });
          throw error;
        });
      }
      return this.fetchPromise;
    };
  }
}), _class);
export const DeviceTrapsStatus = new DeviceTrapsStatusStore();